/* eslint-disable @typescript-eslint/no-explicit-any */
import { Suspense } from 'react';

// project imports
import Loader from './Loader';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: any, fullHeight?: boolean) => (props: any) =>
	(
		<Suspense fallback={<Loader fullHeight={fullHeight} />}>
			<Component {...props} />
		</Suspense>
	);

export default Loadable;
